import {useContext} from 'react';
import {
  MonorailContextProps,
  MonorailContext,
} from 'foundation/Monorail/Monorail';

export function useMonorail(): MonorailContextProps {
  const monorail = useContext(MonorailContext);

  if (!monorail) {
    throw new Error('useMonorail must be used inside a MonorailProvider');
  }

  return monorail;
}
